export default "__VITE_ASSET__BvUouir7__"